import { createContext } from "@lit/context";
const quoteContext = createContext("quote");
export {
  quoteContext
};
